
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class BranchInDialog extends _Ext.TransDialog<BranchInRow, any> {

        protected getFormKey() { return BranchInForm.formKey; }
        protected getIdProperty() { return BranchInRow.idProperty; }
        protected getLocalTextPrefix() { return BranchInRow.localTextPrefix; }
        protected getNameProperty() { return BranchInRow.nameProperty; }
        protected getService() { return BranchInService.baseUrl; }
        protected getDeletePermission() { return BranchInRow.deletePermission; }
        protected getInsertPermission() { return BranchInRow.insertPermission; }
        protected getUpdatePermission() { return BranchInRow.updatePermission; }
        protected useViewMode() { return true; }

        public form = new BranchInForm(this.idPrefix);
        statement: string;
        contractTotals: string;
        TaxArray: any[];
        public Closing: boolean;
        static editorClosed: number;
        MaxDate: Date;
        MinDate: Date;

        constructor() {
            super();
            //Make grid full width
            q.hideEditorLabel(this.form.ItemDetails);
            q.hideEditorLabel(this.form.TaxDetails);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.AdditionalCharges);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.TaxAmount);
            q.setGridEditorHeight(this.form.ItemDetails, 300);
            q.setGridEditorHeight(this.form.TaxDetails, 150);
            q.hideEditorToolbar(this.form.TaxDetails);
            q.hideImageToolbar(this.form.ProductItemImage);
            //To Show Image on Right Top & Hide Categories
            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategoryFourColumn(this.form.BillNo);
            q.SetCategoryTwoColumn(this.form.ProductItemImage);
            q.SetCategoryFullWidth(this.form.ItemDetails);
            q.SetSix12Column(this.form.TaxDetails);
            q.SetCategoryTwoColumn(this.form.Pieces);
            q.SetCategoryFourColumn(this.form.NetAmount);
            q.SetCategoryFullWidth(this.form.Remark);
            q.HideCategoryLable(this.element);
        }



        onDialogClose() {
            this.Closing = true;

        }



        protected onDialogOpen() {
            super.onDialogOpen();


        }

        protected afterLoadEntity() {
            super.afterLoadEntity();
            //this.form.ItemDetails.setOwnerEntity(this.entity);

        }


        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };

            var x = this.entity;
            //Edit Click Override
            var btnEdit = Q.first(btns, x => x.cssClass == "edit-button");
            var oldEditClick = btnEdit.onClick;
            btnEdit.onClick = e => { this.confirmBeforeEdit(oldEditClick, e); };

            btns.push({
                title: 'Authorize',
                cssClass: 'import-xlsx-button',
                onClick: () => {
                    // open import dialog, let it handle rest
                    var dialog = new AuthorizeDialog();
                    dialog.inst = this;
                    dialog.entityId = this.entity.TransId;
                    dialog.element.on('dialogclose', () => {
                        //this.refresh();
                        dialog = null;
                    });
                    dialog.dialogOpen();

                },

            });
            //Export PDF Button
            btns.push(TabAurous.Common.ReportHelper.createToolButton({
                title: 'Print',
                cssClass: 'export-pdf-button',
                icon: 'fa fa-print text-blue',
                reportKey: 'Inventory.BranchInVoucher',
                getParams: () => ({
                    TransID: this.get_entityId()
                })
            }));



            var postingpermission = Q.Authorization.hasPermission('Inventory:BranchIn:Posting');
            //Export PDF Button
            btns.push({
                title: 'Post',
                icon: 'las la-check-double',
                cssClass: 'approve-doc-button',
                onClick: () => {
                    var entity = this.entity;
                    entity.AutoPosting = true; delete entity.TransDate;
                    entity.AuthorizedDate = new Date().toDateString();
                    entity.AuthorizedBy = Q.Authorization.userDefinition.UserId;

                    BranchInService.Update({ Entity: entity, EntityId: entity.TransId }, response => {
                        if (response.Error == null) {
                            this.dialogClose();
                            Serenity.SubDialogHelper.triggerDataChange(this);
                        }
                    }, { async: false })
                },
                visible: postingpermission

            });

            return btns;
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Edit. ****
        private confirmBeforeEdit(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                Serenity.EditorUtils.setReadonly(this.form.ItemDetails.element, false);
                if (!self.isEditMode())
                    return;
                self.editClicked = true;
                self.updateInterface();
                self.updateTitle();
            }
        }
        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )
            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                BranchInService.Delete(
                    {
                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }

        }

        public updateInterface() {
            super.updateInterface();

            this.toolbar.findButton('export-pdf-button').toggle(this.isEditMode());
            if (this.entity.IsPosted) {
                this.toolbar.findButton('approve-doc-button').toggle(true);
                this.form.Posted.setText("Posted");
                this.form.Posted.element.addClass("btn btn-info btn-sm");
                this.toolbar.findButton('approve-doc-button').toggle(!this.isViewMode());
            }
            else {
                this.toolbar.findButton('approve-doc-button').toggle(!this.isViewMode());
                this.form.Posted.setText("Not Posted");
                this.form.Posted.element.addClass("btn btn-warning btn-sm");
                if (this.isNew())
                    q.hideField(this.form.Posted);
            }
            this.toolbar.findButton('export-pdf-button').toggle(this.isEditMode());
            this.element.find('sup').remove();
            this.editButton.remove();
            this.deleteButton.remove();

            if (this.entity.Authorize == true)
                this.toolbar.findButton('import-xlsx-button').addClass('disabled');
            else
                this.toolbar.findButton('import-xlsx-button').removeClass('disabled');
            //Serenity.EditorUtils.setReadonly(btnAuth.cs,true);





        }



        validateEntity(row: BranchInRow, id: number) {

            if (row.ItemDetails.length == 0) {
                Q.alert("No Items added, Atleast add one entry. Can not Save! ")
                return false;
            }
        }
        protected getButtons(): Serenity.ToolButton[] {
            let buttons = super.getToolbarButtons();

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "apply-changes-button"), 1);

            // We could also remove delete button here, but for demonstration 
            // purposes we'll hide it in another method (updateInterface)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "delete-button"), 1);

            return buttons;
        }
    }
}